module.exports = __webpack_public_path__ + "assets/img/6_507_big.bbd57340.jpg";